import {Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScheduleService } from '../services/schedule.service';
import { Schedule } from '../models/schedule';
import { CustomerService } from '../services/customers.service';
import { Customer } from '../models/customer';
import { SelectItem } from 'primeng/api';
import { Template } from '@angular/compiler/src/render3/r3_ast';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  providers: [ScheduleService,CustomerService]
})
export class ReportsComponent implements OnInit {
  public customer: Customer;
  public customerSelected: Customer;
  public stardDateSelected: Date;
  public endDateSelected: Date;
  public dropdownCustomer: SelectItem[];
  public listCustomers: Customer[] = [];
  public listSchedules: Schedule[];
  cols: any[];
  first = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private scheduleService: ScheduleService,
    private customerService: CustomerService
  ) {
    this.cols = [
      {field: 'date1', header: 'Fecha Registro'},
      {field: 'customer', header: 'Cliente'},
      {field: 'identification', header: 'Identificación'},
      {field: 'name', header: 'Nombre'},
      {field: 'email', header: 'Email'},
      {field: 'phoneMobile', header: 'Celular'},
      {field: 'phone', header: 'Teléfono'},
      {field: 'department', header: 'Departamento'},
      {field: 'city', header: 'Ciudad'},
      {field: 'address', header: 'Direccion'},
      {field: 'neighborhood', header: 'Barrio'},
      {field: 'datePickup1', header: 'F.Recolección'},
      {field: 'workShedule', header: 'Horario'},
      {field: 'quantity', header: 'Cantidad'},
      {field: 'nroTicket', header: 'Ticket'},
      {field: 'observation', header: 'Observación'},
    ];
    this.customerSelected = new Customer();
    this.stardDateSelected = new Date();
    this.endDateSelected = new Date();
  }

  ngOnInit() {
    this.getCustomer();
    this.getSchedules();
  }

  getCustomer(){
    this.customerService.getActive(true).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.customer  = response.object;
          this.listCustomers = response.object;
          this.generateDropdownCustomer();
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any> error);
      }
    );
  }
  generateDropdownCustomer(){
    this.dropdownCustomer = [];
    this.dropdownCustomer.push({ label: 'Seleccione', value: null });
    for (const hq of this.listCustomers) {
      this.dropdownCustomer.push({ label: hq.name, value: hq });
    }
  }
  getSchedules() {
    this.listSchedules = [];
    this.scheduleService.get().subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.listSchedules = response.object;
          if (this.listSchedules.length > 0) {
            this.listSchedules.forEach(sch => {
              sch.date1 = this.formatDatesRepots(String(sch.date));
              sch.datePickup1 = this.formatDatesRepots(String(sch.datePickup));
            });
          }
        } else {
          console.log(response);
          alert('No se Encuentran Registros');
        }
      },
      error => {
        console.log( error as any);
        alert('Error en la Consulta');
      }
    );
  }
  getSchedulesFilters() {
    this.listSchedules = [];
    let fini:any;
    let ffin:any;
    if(this.stardDateSelected != null && this.endDateSelected != null)
    {
      
      let date = ("0" + this.stardDateSelected.getDate()).slice(-2);
      let month = ("0" + (this.stardDateSelected.getMonth() + 1)).slice(-2);
      let year = this.stardDateSelected.getFullYear();
      fini = year + "-" + month + "-" + date;
      let datef = ("0" + this.endDateSelected.getDate()).slice(-2);
      let monthf = ("0" + (this.endDateSelected.getMonth() + 1)).slice(-2);
      let yearf = this.endDateSelected.getFullYear();
      ffin = yearf + "-" + monthf + "-" + datef;
    }
    if(this.customerSelected.name!=undefined && this.stardDateSelected === null && this.endDateSelected === null)
    {
      this.scheduleService.getByCustomerId(this.customerSelected.id).subscribe(
        response => {
          if (response.statusCode === '200 OK') {
            this.listSchedules = response.object;
            if (this.listSchedules.length > 0) {
              this.listSchedules.forEach(sch => {
                sch.date1 = this.formatDatesRepots(String(sch.date));
                sch.datePickup1 = this.formatDatesRepots(String(sch.datePickup));
              });
            }
          } else {
            console.log(response);
            alert('No se Encuentran Registros');
          }
        },
        error => {
          console.log( error as any);
          alert('Error en la Consulta');
        }
      );
    }else{
      this.scheduleService.getByCustomerIdDate(this.customerSelected.id, fini, ffin).subscribe(
        response => {
          if (response.statusCode === '200 OK') {
            this.listSchedules = response.object;
            if (this.listSchedules.length > 0) {
              this.listSchedules.forEach(sch => {
                sch.date1 = this.formatDatesRepots(String(sch.date));
                sch.datePickup1 = this.formatDatesRepots(String(sch.datePickup));
              });
            }
          } else {
            console.log(response);
            alert('No se Encuentran Registros');
          }
        },
        error => {
          console.log( error as any);
          alert('Error en la Consulta');
        }
      );
    }
  }
  formatDatesRepots(date: string): string {
    const currentDate: any[] = date.replace('T00:00:00', '').split('-');
    date = currentDate[2] + '/' + currentDate[1] + '/' + currentDate[0];
    return date;
  }

  getDates(date: Date): string {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    if (month < 10 && day < 10) {
      const currentDate = year + '0' + month + '0' + day;
      return currentDate;
    } else if (month >= 10 && day < 10) {
      const currentDate = year + '' + month + '0' + day;
      return currentDate;
    } else if (month < 10 && day >= 10) {
      const currentDate = year + '0' + month + '' + day;
      return currentDate;
    } else if (month >= 10 && day >= 10) {
      const currentDate = year + '' + month + '' + day;
      return currentDate;
    }
  }
  reset() {
    this.first = 0;
  }

  downloadCSV()
  {
    let delimiter = "\\";
    let headers = '';
    let file = '';

    this.cols.forEach(col => {
      headers = headers + col.header + "\\";
    });
    file = headers;
    for (let j = 0; j < this.listSchedules.length; j++) {
      file = file + "\n";
      this.cols.forEach(col => {
        file = file +  this.listSchedules[j][col.field];
        file = file + delimiter;
      });
    }
    let blob = new Blob(['\ufeff' + file], { type: 'text/csv;charset=utf-8;' });
    let url = URL.createObjectURL(blob);
    let downloadLink = document.createElement("a");
    downloadLink.setAttribute("href", url);
    downloadLink.setAttribute("download", 'Download' + ".csv");
    downloadLink.style.visibility = "hidden";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
}
